import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaSave, FaSearch, FaTrash } from "react-icons/fa";

export default function ModalLancamentoManual({ show, onHide, dataInicio, dataFim, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [lancamentos, setLancamentos] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });
    console.log("Data Inicio: " + dataInicio + ' - Data Fim: ' + dataFim);

    useEffect(() => {
        if (show) {
            setForm(initialState); // Limpa os campos de digitação
            setLancamentos([]);    // Limpa a tabela de lançamentos recentes, se desejar
            
            // Se quiser que o modal já abra com as datas que vieram do filtro principal:
            if (dataInicio && dataFim) {
                // Opcional: ajustar as datas do form para as datas vindas da tela principal
                // Note que precisará converter de DD/MM/YYYY para YYYY-MM-DD se usar input type="date"
            }
        }
    }, [show]);

    const [form, setForm] = useState({
        roteamento: '', bandeira: '', condicao: '', loja: '',
        datavenda: new Date().toISOString().split('T')[0],
        datacredito: new Date().toISOString().split('T')[0],
        valorbruto: '', taxaflor: 0
    });
    // Garante o formato 1.234,56
    const formatarNumero = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true // Força o ponto do milhar
        }).format(valor || 0);
    };

    // Garante o formato R$ 1.234,56
    const formatarMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            useGrouping: true
        }).format(Number(valor || 0));
    };

    const [filtros, setFiltros] = useState({
        dtini: dataInicio,
        dtfim: dataFim
    });

    useEffect(() => {
        if (show) {

            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
                .catch(err => console.error("Erro roteamentos:", err));
        }
    }, [show]);

    const renderOptions = (lista, campo) => {
        return lista.map((item, index) => {
            const valor = typeof item === 'object' ? item[campo] : item;
            return <option key={index} value={valor}>{valor}</option>;
        });
    };

    const initialState = {
        roteamento: '',
        bandeira: '',
        condicao: '',
        loja: '',
        datavenda: new Date().toISOString().split('T')[0],
        datacredito: new Date().toISOString().split('T')[0],
        valorbruto: '',
        taxaflor: 0
    };

    const atualizarLista = async () => {
        if (!form.roteamento) return;
        try {
            // No GET do Axios, os dados DEVEM estar dentro da chave 'params'
            const res = await api.get('/financeiro/conciliacao/manual/listar', {
                params: {
                    dtini: formatarDataBR(dataInicio),
                    dtfim: formatarDataBR(dataFim),
                    roteamento: form.roteamento,
                    bandeira: form.bandeira || '',
                    condicao: form.condicao || ''
                }
            });
            setLancamentos(res.data);
            console.log('Lista ' + res.data);
        } catch (err) {
            console.error("Erro ao listar:", err);
            // Se o erro 500 persistir, o problema está na forma como o Delphi lê os parâmetros
        }
    };

    const handleExcluir = async (item) => {
        const confirmacao = await Swal.fire({
            title: 'Excluir Lançamento?',
            text: "Esta ação não pode ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (!confirmacao.isConfirmed) return;

        try {
            setLoading(true);
            // Os campos devem bater com o que o Delphi espera no Req.Query
            await api.delete('/financeiro/conciliacao/manual', {
                params: {
                    dtini: formatarDataBR(item.DATAVENDA || item.datavenda),
                    dtfim: formatarDataBR(item.DATAVENDA || item.datavenda), // Exclui o movimento daquele dia específico
                    roteamento: item.ROTEAMENTO || item.roteamento || form.roteamento,
                    bandeira: item.BANDEIRA || item.bandeira,
                    condicao: item.CONDICAO || item.condicao,
                    loja: item.LOJA || item.loja
                }
            });

            Swal.fire("Sucesso", "Lançamento excluído!", "success");
            atualizarLista(); // Recarrega a grid
        } catch (err) {
            Swal.fire("Erro", "Falha ao excluir: " + (err.response?.data?.erro || "Erro interno"), "error");
        } finally {
            setLoading(false);
        }
    };


    const handleSalvar = async () => {
        // Validação corrigida (removido o formatarDataBR do IF que estava causando erro de lógica)
        if (!form.roteamento || !form.loja || !form.valorbruto || !form.datavenda || !form.datacredito) {
            Swal.fire("Erro", "Preencha todos os campos obrigatórios.", "error");
            return;
        }

        setLoading(true);

        // Criamos o payload formatando as datas para o que o seu backend espera
        const payload = {
            ...form,
            datavenda: formatarDataBR(form.datavenda),
            datacredito: formatarDataBR(form.datacredito)
        };

        try {
            await api.post('/financeiro/conciliacao/manual', payload);
            Swal.fire("Sucesso", "Lançamento realizado!", "success");
            atualizarLista();
            // Limpa apenas o valor bruto para novo lançamento, mantendo as configs de roteamento/loja
            setForm({ ...form, valorbruto: '' });
        } catch (err) {
            Swal.fire("Erro", "Falha ao salvar: " + (err.response?.data?.error || "Erro interno"), "error");
        } finally {
            setLoading(false);
        }
    };

    const handleRoteamento = async (val) => {
        setForm({ ...form, roteamento: val, bandeira: '', condicao: '', taxaflor: 0 });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) { console.error(err); }
    };

    const handleBandeira = async (val) => {
        setForm(prev => ({ ...prev, bandeira: val, condicao: '', taxaflor: 0 }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) { console.error(err); }
    };

    const handleCondicao = async (val) => {
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/taxa?roteamento=${form.roteamento}&bandeira=${form.bandeira}&condicao=${val}`);
            const valorTaxa = res.data.TAXA || res.data.taxa || 0;
            setForm(prev => ({ ...prev, condicao: val, taxaflor: valorTaxa }));
        } catch (err) { console.error(err); }
    };

    const formatarDataBR = (valor) => {
        if (!valor) return '';

        // Caso venha nesse formato: Sat Jan 03 2026 00:00:00 GMT-0300
        if (typeof valor === 'string' && valor.includes('GMT')) {
            const d = new Date(valor);
            if (!isNaN(d)) {
                const dia = String(d.getDate()).padStart(2, '0');
                const mes = String(d.getMonth() + 1).padStart(2, '0');
                const ano = d.getFullYear();
                return `${dia}/${mes}/${ano}`;
            }
        }

        // Se for Date real
        if (valor instanceof Date) {
            const dia = String(valor.getDate()).padStart(2, '0');
            const mes = String(valor.getMonth() + 1).padStart(2, '0');
            const ano = valor.getFullYear();
            return `${dia}/${mes}/${ano}`;
        }

        const s = String(valor).trim();

        // formato DD/MM/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) {
            return s.substring(0, 10);
        }

        // formato ISO
        if (s.includes('-')) {
            const parts = s.split('T')[0].split('-');
            if (parts.length === 3) {
                const [y, m, d] = parts;
                return `${d}/${m}/${y}`;
            }
        }

        return s;
    };


    // Adicione este useEffect logo abaixo dos outros
    useEffect(() => {
        // Só dispara se houver ao menos um roteamento selecionado
        if (form.roteamento) {
            atualizarLista();
        } else {
            setLancamentos([]); // Limpa a lista se desmarcar o roteamento
        }
        // Adicione os filtros na dependência também, para buscar ao mudar datas
    }, [form.roteamento, form.bandeira, form.condicao, filtros.dtini, filtros.dtfim]);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            <Modal.Header closeButton className="bg-primary text-white p-2">
                <Modal.Title className="small fw-bold ms-2">LANÇAMENTO MANUAL</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <div className="card p-3 shadow-sm border-0 mb-3">
                    <Row className="g-2">
                        <Col md={3}>
                            <label className="small fw-bold">Roteamento</label>
                            <Form.Select size="sm" value={form.roteamento} onChange={e => handleRoteamento(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.roteamentos, 'ROTEAMENTO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Bandeira</label>
                            <Form.Select size="sm" value={form.bandeira} onChange={e => handleBandeira(e.target.value)} disabled={!form.roteamento}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.bandeiras, 'BANDEIRA')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Condição</label>
                            <Form.Select size="sm" value={form.condicao} onChange={e => handleCondicao(e.target.value)} disabled={!form.bandeira}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.condicoes, 'CONDICAO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Loja</label>
                            <Form.Control size="sm" type="number" value={form.loja} onChange={e => setForm({ ...form, loja: e.target.value })} />
                        </Col>

                        {/* NOVOS CAMPOS ADICIONADOS AQUI */}
                        <Col md={3}>
                            <label className="small fw-bold">Data Venda</label>
                            <Form.Control
                                size="sm"
                                type="date"
                                value={form.datavenda}
                                onChange={e => setForm({ ...form, datavenda: e.target.value })}
                            />
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Data Crédito</label>
                            <Form.Control
                                size="sm"
                                type="date"
                                value={form.datacredito}
                                onChange={e => setForm({ ...form, datacredito: e.target.value })}
                            />
                        </Col>
                        {/* ---------------------------- */}

                        <Col md={2}>
                            <label className="small fw-bold">Valor Bruto</label>
                            <Form.Control size="sm" type="number" value={form.valorbruto} onChange={e => setForm({ ...form, valorbruto: e.target.value })} />
                        </Col>
                        <Col md={2}>
                            <label className="small fw-bold text-danger">Taxa (%)</label>
                            <div className="form-control form-control-sm bg-white fw-bold text-center">{form.taxaflor}%</div>
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            <Button variant="success" size="sm" className="w-100 fw-bold" onClick={handleSalvar} disabled={loading}>
                                <FaSave className="me-2" /> GRAVAR
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="card p-2 shadow-sm border-0">
                    <div className="table-responsive" style={{ maxHeight: '300px' }}>
                        <Table striped bordered hover size="sm" className="small text-center">
                            <thead className="table-secondary sticky-top">
                                <tr>
                                    <th>Loja</th>
                                    <th>Data Venda</th>
                                    <th>Data Crédito</th>
                                    <th>Valor Bruto</th>
                                    <th>Taxa %</th>
                                    <th>Valor Taxa</th>
                                    <th>Ação</th> {/* Nova Coluna */}
                                </tr>
                            </thead>
                            <tbody>
                                {lancamentos.map((l, i) => (
                                    <tr key={i} className="align-middle">
                                        <td>{l.LOJA || l.loja}</td>
                                        <td>{formatarDataBR(l.DATAVENDA || l.datavenda)}</td>
                                        <td>{formatarDataBR(l.DATACREDITO || l.datacredito)}</td>
                                        <td>{formatarMoeda(l.VALORBRUTO || l.valorbruto || 0)}</td>
                                        <td>{Number(l.TAXA || l.taxa || 0).toFixed(2)}%</td>
                                        <td className="text-danger fw-bold"> {formatarMoeda(l.VALORTAXA || l.valortaxa || 0)}</td>
                                        <td>
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => handleExcluir(l)}
                                                title="Excluir este lançamento"
                                            >
                                                <FaTrash />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}